module.exports = __webpack_public_path__ + "assets/img/stage-light-01c5acd3.png";